import { Base } from "ui/Scripts/source/framework/base";
import { EventSettingSimple, IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IEventDefaultEventHandlers {
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    canHandleEvent: boolean;
    canEditIdentificationData: boolean;
    handlers: IModifyUser[];
    eventSetting: IEventSettingSimple;
}

export class EventDefaultEventHandlers implements IEventDefaultEventHandlers {
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    canHandleEvent: boolean;
    canEditIdentificationData: boolean;
    handlers: ModifyUser[];
    eventSetting: EventSettingSimple;

    constructor();
    constructor(obj: IEventDefaultEventHandlers);
    constructor(obj?: any) {
        this.unitId = obj && obj.unitId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.createCompanyUnitId = obj && obj.createCompanyUnitId || "";
        this.createCompanyUnitCode = obj && obj.createCompanyUnitCode || "";
        this.canHandleEvent = obj && obj.canHandleEvent || false;
        this.canEditIdentificationData = obj && obj.canEditIdentificationData || false;
        this.handlers = Base.getTypedArray(obj ? obj.handlers : null, ModifyUser);
        this.eventSetting = new EventSettingSimple(obj?.eventSetting);
    }
}